import {
  jb_burger_icon_css_default
} from "./chunk.34UA6E3F.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-burger-icon/jb-burger-icon.ts
var JbBurgerIcon = class extends Icon(i) {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  firstUpdated() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent("burger-icon:clicked", { bubbles: true, composed: true }));
    });
  }
  render() {
    return b`<svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="7"
        x2="41"
        y1="12.7"
        y2="12.7"
      />
      <line
        x1="7"
        x2="41"
        y1="22.8"
        y2="22.8"
      />
      <line
        x1="7"
        x2="41"
        y1="33"
        y2="33"
      />
    </svg>`;
  }
};
JbBurgerIcon.styles = [reset_css_default, jb_burger_icon_css_default];
__decorateClass([
  n({ type: Boolean, reflect: true })
], JbBurgerIcon.prototype, "isOpen", 2);
JbBurgerIcon = __decorateClass([
  customElement("jb-burger-icon")
], JbBurgerIcon);

export {
  JbBurgerIcon
};
